import React from 'react';
import './setting.modal.sass';
import {Alert, Button, Col, ControlLabel, Form, FormControl, FormGroup, Modal, Row, SelectPicker} from "rsuite";
import {connect} from 'react-redux';
import {createStructuredSelector} from "reselect";
import modalsTypes from "../../redux/modals/modals.types";
import {selectToggleSettingModal} from "../../redux/modals/modals.selector";
import {selectSelectedCarInfo} from "../../redux/cars/cars.selector";
import {selectIsDemo, selectToken, selectUserInfo} from "../../redux/user/user.selector";
import selectData from '../../data/icons.json'

//ICON IMPORT
import carg from '../../assets/icons/carg.png';
import vang from '../../assets/icons/van_green.png';
import truckg from '../../assets/icons/truck_green.png';
import taxig from '../../assets/icons/taxi_green.png';
import busg from '../../assets/icons/bus_green.png';
import motorg from '../../assets/icons/motor_green.png';
import bicycleg from '../../assets/icons/bicycle_green.png';
import shipg from '../../assets/icons/ship_green.png';
import metrog from '../../assets/icons/metro_green.png';
import ambolanceg from '../../assets/icons/ambolance_green.png';
import dogg from '../../assets/icons/dog_green.png';
import persong from '../../assets/icons/person_green.png';
import Axios from "axios";
import {selectIsMain} from "../../redux/map/map.selector";


class SettingModal extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            value: 0,
            loading: false
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(value) {
        this.setState({
            value
        });
    }

    render() {
        const {selectedCar, ToggleSettingModal, settingModalNow , IsDemo, getToken} = this.props;

        const handleSubmit = () => {
            this.setState({loading: true});
            if(IsDemo){
                Alert.error('در تست پنل، قادر به تغییر تنظیمات نیستید !', 5000)
            }else {
                const {getUserData} = this.props;
                const NMS = document.getElementById('NewMaxSpeed').value;
                const NewMaxSpeed = `${NMS ? NMS : selectedCar.MaxSpeed}`;
                const MT = document.getElementById('NewMaxTemp').value;
                const NewMaxTemp = `${MT ? MT : selectedCar.MaxTemp}`;
                const MinT = document.getElementById('NewMinTemp').value;
                const NewMinTemp = `${MinT ? MinT : selectedCar.MinTemp}`;
                const NN = document.getElementById('NewName').value;
                const NewName = `${NN ? NN : selectedCar.NAME}`;
                const NF = document.getElementById('NewFuel').value;
                const NewFuel = `${NF ? NF : selectedCar.Fuel}`;
                const phone = getUserData.phone;
                const pass = getUserData.pass;
                const id = getUserData.id;

                const data = {
                    phone: phone,
                    pass: pass,
                    id: id,
                    icon: this.state.value,
                    maxspeed: NewMaxSpeed,
                    maxtemp: NewMaxTemp,
                    mintemp: NewMinTemp,
                    car_name: NewName,
                    fuel: NewFuel
                };
                Axios.post(`${getToken}/setSettings`, JSON.stringify(data))
                    .then((res) => {
                        if (res.data.success === 'true') {
                            Alert.success('تنظیمات جدید اعمال شد.');
                            ToggleSettingModal();
                        } else {
                            Alert.error('مشکلی در برقراری ارتباط به وجود آمده، لطفا دباره تلاش کنید')
                        }
                        this.setState({loading: false});
                    });
            }
        };
        const imageUrl = (val) => {
            let url;
            //Switch
            switch (val){
                case 0:
                    return url = carg;
                case 1:
                    return url = vang;
                case 2:
                    return url = truckg;
                case 3:
                    return url = taxig;
                case 4:
                    return url = busg;
                case 5:
                    return url = motorg;
                case 6:
                    return url = bicycleg;
                case 7:
                    return url = shipg;
                case 8:
                    return url = metrog;
                case 9:
                    return url = ambolanceg;
                case 10:
                    return url = dogg;
                case 11:
                    return url = persong;
                default:
                    return url = carg
            }
        };

        return (
            <div className="modal-container">
                <Modal size='xs' show={settingModalNow} onHide={() => ToggleSettingModal()}>
                    <Form>
                        <Modal.Header>
                            <Modal.Title>تنظیمات {selectedCar.NAME}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <FormGroup>
                                <ControlLabel>نام دستگاه :</ControlLabel>
                                <FormControl type='text' placeholder={selectedCar.NAME} id='NewName'/>
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>کاربر اختصاصی :</ControlLabel>
                                <SelectPicker
                                    id="newApplication"
                                    style={{width: 224}}
                                    data={selectData}
                                    appearance="default"
                                    placeholder="پیش فرض"
                                    onChange={this.handleChange}
                                    value={this.state.value}
                                />
                                <img src={imageUrl(this.state.value)} style={{width: '30px', marginRight: '20px'}} alt='xitonix car logo'/>
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>متوسط مصرف سوخت در صد کیلومتر</ControlLabel>
                                <FormControl type='number' placeholder={selectedCar.Fuel} id='NewFuel'/>
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>اخطار حداکثر سرعت دستگاه</ControlLabel>
                                <FormControl type='number' placeholder={selectedCar.MaxSpeed} id='NewMaxSpeed'/>
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>اخطار حداکثر دما دستگاه</ControlLabel>
                                <FormControl type='number' placeholder={selectedCar.MaxTemp} id='NewMaxTemp'/>
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>اخطار حداقل دما دستگاه</ControlLabel>
                                <FormControl type='number' placeholder={selectedCar.MinTemp} id='NewMinTemp'/>
                            </FormGroup>
                        </Modal.Body>
                        <Modal.Footer>
                            <Row>
                                <Col xs={12}>
                                    <Button onClick={() => ToggleSettingModal()} block className='BtnClose'>
                                        بستن
                                    </Button>
                                </Col>
                                <Col xs={12}>
                                    <Button onClick={() => handleSubmit()} block className='Btn1'
                                            loading={this.state.loading}
                                    >
                                        اعمال
                                    </Button>
                                </Col>
                            </Row>
                        </Modal.Footer>
                    </Form>
                </Modal>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    ToggleSettingModal: () => dispatch({type: modalsTypes.TOGGLE_SETTING_MODAL}),
});

const mapStateToProps = createStructuredSelector({
    settingModalNow: selectToggleSettingModal,
    selectedCar: selectSelectedCarInfo,
    getUserData: selectUserInfo,
    IsDemo: selectIsDemo,
    getToken: selectToken
});


export default connect(mapStateToProps, mapDispatchToProps)(SettingModal);